import { update, type UpdateExpression } from 'mingo/updater';
import type { JsonObject, ValueOf } from 'type-fest';

export const MingoUpdateOperators = {
  SET: '$set' satisfies keyof UpdateExpression,
  UNSET: '$unset' satisfies keyof UpdateExpression,
} as const;

export type MingoUpdateOperator = ValueOf<typeof MingoUpdateOperators>;

interface MingoUpdateSuccess {
  success: true;
  updatedObject: JsonObject;
  updatedFields: string[];
}

interface MingoUpdateError {
  success: false;
  error: string;
}

export type MingoUpdateResult = MingoUpdateSuccess | MingoUpdateError;

export const applyMingoUpdateOperation = (
  objectToUpdate: JsonObject,
  operation: UpdateExpression
): MingoUpdateResult => {
  const clonedObject = structuredClone(objectToUpdate);

  try {
    const updatedFields = update(clonedObject, operation);
    return {
      success: true,
      updatedObject: clonedObject,
      updatedFields,
    };
  } catch (error: unknown) {
    return {
      success: false,
      error: error instanceof Error ? error.message : String(error),
    };
  }
};
